module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div>\n	")
    ;  for (var i = 0; i < widget.columns.length; i++) { 
    ; __append("\n	<div>")
    ; __append(escapeFn( item[widget.columns[i]] ))
    ; __append("</div>\n	")
    ;  } 
    ; __append("\n	<div style=\"width: 30px; text-align: center\"><div name=\"remove-button\" class=\"icon-trash-o\" data-json=\"")
    ; __append(escapeFn( JSON.stringify(item) ))
    ; __append("\"></div></div>\n</div>\n")
  }
  return __output.join("");

}